import { ChangeEvent } from "react"
import { useHistory } from "react-router-dom"
import routes from "../../helpers/routes"
import useAuth from "../../hooks/useAuth"
import { Customer } from "../../utils/api/customers"
import { CustomerBasicInfo } from './CustomerForm/CustomerBasicInfo'
import { PriceListSection } from './CustomerForm/PriceListSection'
import { ContactsSection } from './CustomerForm/ContactsSection'

interface ICustomerFormProps {
  customer: Customer
  setCustomer: React.Dispatch<React.SetStateAction<Customer | undefined>>
  handleSubmit: (customer: Customer) => void
}

export default function CustomerForm({
  customer = {} as Customer,
  setCustomer,
  handleSubmit
}: ICustomerFormProps) {
  const history = useHistory();
  const { user } = useAuth()

  const handleChange = (e: ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setCustomer({
      ...customer,
      [e.target.name]: e.target.value
    })
  }

  const handleChangeCheckbox = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCustomer({
      ...customer,
      [event.target.name]: event.target.checked
    })
  }

  const submitForm = (e: React.FormEvent<Element>) => {
    e.preventDefault();
    handleSubmit(customer);
  }

  return (
    <div>
      <form onSubmit={submitForm}>
        <CustomerBasicInfo
          customer={customer}
          handleChange={handleChange}
          handleChangeCheckbox={handleChangeCheckbox}
          user={user}
        />
        
        <PriceListSection
          customer={customer}
          setCustomer={setCustomer}
          user={user}
        />
        
        <ContactsSection
          customer={customer}
          setCustomer={setCustomer}
        />

        <div className="d-flex gap-2">
          <button className="btn btn-secondary" onClick={() => history.push(routes.customer(customer.id))}>Cancelar</button>
          <button className="btn btn-primary" type="submit">
            Guardar
          </button>
        </div>
      </form>
    </div>
  )
}